export const hasSignatureTerms = (documents)=>documents.some((document)=>(document === null || document === void 0 ? void 0 : document.termsOfService.type) === 'signature');
